var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlotoCrudContainer',{attrs:{"as-table":"","prepend-new-item":"","fetch-fn":_vm.getRecentCall,"columns":_vm.tableColumns},scopedSlots:_vm._u([{key:"callTime",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"text-ellipsis"},[_vm._v(" "+_vm._s(_vm._f("datetime")(item.callTime))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }